import React, { lazy, Suspense, useCallback, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CFooter, CHeader } from '@coreui/react';
import { AuthContext } from 'contexts/AuthContext';
import { useDevice } from 'hooks/useMediaQuery';
import { Sidebar } from './Sidebar';

const Footer = lazy(() => import('components/Layout/Footer/index'));
const Header = lazy(() => import('components/Layout/Header/index'));

export const Layout = ({ children }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { state } = useContext(AuthContext);
    const { isMobile } = useDevice();

    useEffect(() => {
        if (!state.isAuthenticated) {
            navigate(pathname.includes('admin') ? '/admin/signin' : '/signin');
        }
    }, [state]);

    const [isCloseSidebar, setIsCloseSidebar] = useState(false);
    const [isCloseBurger, setIsCloseBurger] = useState(isMobile);

    const loading = useCallback(
        () => (
            <div className="animated fadeIn pt-1 text-center">
                <div className="sk-spinner sk-spinner-pulse"/>
            </div>
        ),
        []
    );

    useEffect(() => {
        setIsCloseBurger(isMobile);
    }, [isMobile]);

    if (!state?.isAuthenticated) {
        return <div className="app"></div>;
    }

    return (
        <div className="app">
            <CHeader style={{ zIndex: '1050' }}>
                <Suspense fallback={loading()}>
                    <Header isCloseBurger={isCloseBurger} setIsCloseBurger={setIsCloseBurger}/>
                </Suspense>
            </CHeader>
            <div id="app-main-body" className="app-body">
                <Sidebar isCloseSidebar={isCloseSidebar} setIsCloseSidebar={setIsCloseSidebar}
                         isCloseBurger={isCloseBurger}/>
                <main className={'main ' + (isCloseBurger ? '' : isCloseSidebar ? 'm-50' : 'm-200')}>
                    <Suspense fallback={loading()}>{children}</Suspense>
                </main>
            </div>
            <CFooter className={isCloseBurger ? '' : isCloseSidebar ? 'm-50' : 'm-200'}>
                <Suspense fallback={loading()}>
                    <Footer/>
                </Suspense>
            </CFooter>
        </div>
    );
};
